var poll_default = {
  "fontElementMap": "DNoxy",
  "container": "nvI1G",
  "fullscreen": "rNOAj",
  "background_overlay": "FTHU-",
  "with_image": "npNW6",
  "options": "YCAPs",
  "webview": "_2243S",
  "grid": "E89L4",
  "option": "YzCkZ",
  "cta_button": "dOktO",
  "add_option": "-TsnB",
  "see_more": "leSt7",
  "list": "_0618-",
  "column": "_2lRLZ",
  "additional_note": "ZhDPL",
  "spinner": "_2q8WL",
  "spin": "z2LDr",
  "shown": "_8nOpU",
  "error": "sZSdJ"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
